/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * imgBaseUrl: 图片所在域名地址
 */

// let attachmentBaseUrl = 'http://192.168.0.229:210'
// let baseUrl = 'http://192.168.0.229:300'

// let attachmentBaseUrl = 'http://192.168.6.102:210'
// let baseUrl = 'http://192.168.6.102:210'

// let attachmentBaseUrl = 'http://192.168.6.102:210'
// let baseUrl = 'http://192.168.6.102:210'


   let baseUrl = '//api.360gcb.com'
   let attachmentBaseUrl = '//api.360gcb.com'


// let baseUrl = 'http://192.168.6.90:3000'
// let attachmentBaseUrl = 'http://192.168.6.90:3000'

// let baseUrl = 'http://192.168.6.85:210'
// let attachmentBaseUrl = 'http://192.168.6.85:210'

//let baseUrl = 'http://192.168.6.90:3000'
//let attachmentBaseUrl = 'http://192.168.6.90:3000'


// let baseUrl = 'http://192.168.0.229:210'
// let attachmentBaseUrl = 'http://192.168.0.172:210/'
//let baseUrl = 'http://192.168.0.228:200/'
// let baseUrl = 'http://192.168.0.229:7878/'
// let baseUrl = 'http://192.168.0.229:210'


if(process.env.NODE_ENV == 'development') {

} else if(process.env.NODE_ENV == 'production') {

}

export {
	baseUrl,
	attachmentBaseUrl,
}


// WEBPACK FOOTER //
// ./src/js/env.js